import * as React from "react";
import Box from "@amzn/awsui-components-react/polaris/box";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import Button from "@amzn/awsui-components-react/polaris/button";
import "../styles.scss"; // Ensure you have an external CSS file
import "../../howtouse/styles.css";
import ButtonDropdown from "@amzn/awsui-components-react/polaris/button-dropdown";
import logo from "/logo.png";
import { usePresentation } from "../../../context/PresentationContext";
import { useData } from "../../../context/DataContext";
import { useState } from "react";

export default function LoginPage() {
  const { setSelectedShift, setSelectedDepartment, setSelectedSite } =
    usePresentation();
  //const { setSiteID, fetchData } = useData();

  // Initialize state with values from localStorage or defaults
  const [localSite, setLocalSite] = React.useState(
    () => localStorage.getItem("localSite") || "Choose Site",
  );
  const [localShift, setLocalShift] = React.useState(
    () => localStorage.getItem("localShift") || "Choose Shift",
  );
  const [localDepartment, setLocalDepartment] = React.useState(
    () => localStorage.getItem("localDepartment") || "Choose Department",
  );

  // Update localStorage when values change
  const updateLocalSite = (value: string) => {
    setLocalSite(value);
    localStorage.setItem("localSite", value);
  };

  const updateLocalShift = (value: string) => {
    setLocalShift(value);
    localStorage.setItem("localShift", value);
  };

  const updateLocalDepartment = (value: string) => {
    setLocalDepartment(value);
    localStorage.setItem("localDepartment", value);
  };

  const [fetchError, setFetchError] = useState<string | null>(null);

  // Onboarding a new site: add it here AND grant its users sign-in access on
  // the Federate service profile. See docs/onboarding-new-site.md.
  const sites = [
    { text: "BFI3", id: "BFI3" },
    { text: "BUR7", id: "BUR7" },
    { text: "CLT2", id: "CLT2" },
    { text: "FOE1", id: "FOE1" },
    { text: "LGB4", id: "LGB4" },
    { text: "QYY6", id: "QYY6" },
    { text: "OLM1", id: "OLM1" },
    { text: "RMN3", id: "RMN3" },
    { text: "RNT9", id: "RNT9" },
    { text: "SBD3", id: "SBD3" },
    { text: "SCK8", id: "SCK8" },
    { text: "WPT2", id: "WPT2" },
  ];
  const shifts = [
    { text: "FHD", id: "FHD" },
    { text: "FHN", id: "FHN" },
    { text: "BHD", id: "BHD" },
    { text: "BHN", id: "BHN" },
    { text: "Support", id: "SP" },
  ];
  const departments = [
    // { text: "Inbound", id: "Inbound" },
    // { text: "Outbound", id: "Outbound" },
    { text: "Onebound", id: "Onebound" },
  ];

  const handleLetGo = () => {
    console.log("Let's Go");
    // Save selections to context before navigating
    setSelectedSite(localSite);
    setSelectedShift(localShift);
    setSelectedDepartment("Onebound");

    // Update localStorage with final values
    localStorage.setItem("localSite", localSite);
    localStorage.setItem("localShift", localShift);
    localStorage.setItem("localDepartment", "Onebound");
    console.log("selectedSite", localSite);
    console.log("selectedDepartment", localDepartment);
    console.log("selectedShift", localShift);

    //setSiteID(localSite);
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // Full viewport height
        width: "100vw", // Full viewport width
        position: "relative",
      }}
    >
      <div className="howto-entry">
        {/* Opens in a new tab so users can follow the guide while using the app. */}
        <Button
          href="#/how-to-use"
          target="_blank"
          iconName="status-info"
          ariaLabel="How to use (opens in a new tab)"
        >
          How to use
        </Button>
      </div>
      <Box
        margin={"xxxl"}
        fontSize="display-l"
        padding="m"
        // backgroundColor="blue"
        textAlign="center"
        //color="white"
        // height="100px"
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <img
            src={logo}
            alt="DigiGemba Logo"
            style={{
              height: "60px", // Adjust size as needed
              width: "auto",
              marginRight: "10px",
            }}
          />
          DigiGemba
        </div>
        <div className="button-wrapper">
          <SpaceBetween direction="horizontal" size="xs">
            <ButtonDropdown
              items={sites}
              onItemClick={(e) => {
                updateLocalSite(e.detail.id);
              }}
            >
              {localSite}
            </ButtonDropdown>
            <ButtonDropdown
              items={shifts}
              onItemClick={(e) => {
                updateLocalShift(e.detail.id);
              }}
            >
              {localShift}
            </ButtonDropdown>
            {/* <ButtonDropdown
              items={departments}
              onItemClick={(e) => {
                updateLocalDepartment(e.detail.id);
              }}
            >
              {localDepartment}
            </ButtonDropdown> */}
          </SpaceBetween>
        </div>
        <Button
          disabled={
            !localSite ||
            !localShift ||
            //!localDepartment ||
            localSite === "Choose Site"
            // localShift === "Choose Shift"
            // localDepartment === "Choose Department"
          }
          variant="primary"
          href="#/home"
          onClick={handleLetGo} // Add onClick handler
        >
          Let's Go
        </Button>
        {fetchError && <div>Error: {fetchError}</div>}
      </Box>
    </div>
  );
}
